import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import type { AmendmentRequest } from "@/features/journal-version-list";
import { UserBubbleLinkText } from "@shared/ui";
import "./journals-amendments-rejection-reason.scss";

dayjs.extend(utc);
dayjs.extend(timezone);

interface JournalsAmendmentsRejectionReasonProps {
  request: AmendmentRequest;
}

export const JournalsAmendmentsRejectionReason = ({
  request,
}: JournalsAmendmentsRejectionReasonProps) => {
  const rejectedAt = dayjs
    .utc(request.updatedAt)
    .tz("Europe/Moscow");

  return (
    <div className="journals-amendments-rejection-reason">
      <div className="journals-amendments-rejection-reason__header">
        <span className="journals-amendments-rejection-reason__title">
          Причина изменений
        </span>
        <span className="journals-amendments-rejection-reason__date">
          <span>{rejectedAt.format("HH:mm")} МСК</span>
          <span>{rejectedAt.format("DD.MM.YY")}</span>
        </span>
      </div>
      <div className="journals-amendments-rejection-reason__message">
        {request.rejectionComment || "Причина не указана"}
      </div>
      <div className="journals-amendments-rejection-reason__author">
        Подписант{" "}
        <UserBubbleLinkText>
          {request.rejectionAuthor || request.checkedBy}
        </UserBubbleLinkText>
      </div>
    </div>
  );
};
